import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import {
  getProgramAges,
  getInstitutionProgramAges,
} from "../../slices/codeBookSlice";

export const useGetProgramAges = () => {
  const programAges = useSelector(
    (state: RootState) => state.codeBook.programAges
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProgramAges());
  }, [dispatch]);

  return programAges;
};

export const useGetInstitutionProgramAges = (
  pedagogicalYearInstitutionId: number
) => {
  const filteredProgramAges = useSelector(
    (state: RootState) => state.codeBook.filteredProgramAges
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getInstitutionProgramAges(pedagogicalYearInstitutionId));
  }, [pedagogicalYearInstitutionId, dispatch]);

  return filteredProgramAges;
};
